import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErroService } from 'src/app/service/erros/erro.service';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Router } from '@angular/router';
import { SagresService } from './sagres.service';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-sagres',
  templateUrl: './sagres.component.html',
  styleUrls: ['./sagres.component.css'],
})
export class SagresComponent implements OnInit {
  form: FormGroup;
  competencias: CompetenciaDTO[] = [];
  baixando = false;
  gerandoZip = false;

  xmls: XmlArquivo[] = [
    { nome: 'Servidor.xml', endpoint: 'servidor', status: 'pendente', base64: null },
    { nome: 'Vinculo.xml', endpoint: 'vinculo', status: 'pendente', base64: null },
    { nome: 'Dependente.xml', endpoint: 'dependente', status: 'pendente', base64: null },
    { nome: 'Cargo.xml', endpoint: 'cargo', status: 'pendente', base64: null },
    {
      nome: 'ClasseNivelFaixa.xml',
      endpoint: 'classe-nivel-faixa',
      status: 'pendente',
      base64: null,
    },
    {
      nome: 'HistoricoFuncional.xml',
      endpoint: 'historico-funcional',
      status: 'pendente',
      base64: null,
    },
    { nome: 'FolhaPagamento.xml', endpoint: 'folha-pagamento', status: 'pendente', base64: null },
    {
      nome: 'CodigoVantagemDesconto.xml',
      endpoint: 'codigo-vantagem-desconto',
      status: 'pendente',
      base64: null,
    },
    {
      nome: 'VantagemDesconto.xml',
      endpoint: 'vantagem-desconto',
      status: 'pendente',
      base64: null,
    },
    { nome: 'Lotacao.xml', endpoint: 'lotacao', status: 'pendente', base64: null },
  ];

  progresso = {
    total: 0,
    concluidos: 0,
    percentual: 0,
  };

  localStorage: LocalStorage;
  sigla: string = '';
  empfil: string = '';

  folhaPagamentoContent: any[] = [];
  carregandoFolha = false;
  vantagemDescontoContent: any[] = [];
  vantagemDescontoTotais: any = {};
  servidoresContent: any[] = [];
  dependentesContent: any[] = [];
  ultimoCPFServidor: string | null = null;

  relacaoParentescoDescricao: any = {
    1: 'Cônjuge/Companheiro',
    2: 'Ex-cônjuge/Ex-companheiro',
    3: 'Filho',
    4: 'Enteado',
    5: 'Tutelado',
    6: 'Pai/mãe',
    7: 'Irmão',
    9: 'Outros',
  };

  constructor(
    public fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private erroService: ErroService,
    private sagresService: SagresService,
    private router: Router
  ) {
    this.localStorage = this.decryptLocalStorage();
    this.sigla = this.getSigla();
    this.empfil = this.getEmpfil();

    this.form = this.fb.group({
      competencia: ['', [Validators.required, this.validaCompetencia.bind(this)]],
    });

    this.verificarAutenticacao();
  }

  ngOnInit(): void {
    this.carregarCompetencias();
  }

  getParentesco(codigo: string): string {
    return this.relacaoParentescoDescricao[codigo] || 'N/A';
  }

  carregarCompetencias(): void {
    this.spinner.show('competencias');

    this.sagresService.listarCompetencias(this.sigla, this.empfil).subscribe({
      next: (data: any) => {
        this.competencias = Array.isArray(data?.result) ? data.result : [];
        if (!this.competencias.length && Array.isArray(data)) {
          this.competencias = data;
        }
        this.spinner.hide('competencias');
      },
      error: (err) => {
        console.error('❌ Erro ao carregar competências:', err);
        this.erroService.retornoErro(err);
        this.spinner.hide('competencias');
      },
    });
  }

  mostrarCPFServidor(cpf: string): boolean {
    if (!this.ultimoCPFServidor) {
      this.ultimoCPFServidor = cpf;
      return true;
    }

    if (this.ultimoCPFServidor === cpf) {
      return false;
    }

    this.ultimoCPFServidor = cpf;
    return true;
  }

  carregarDependentes(sigla: string, dtcomp: string, empfil: string) {
    this.ultimoCPFServidor = null;

    this.sagresService.buscarDependentes(sigla, dtcomp, empfil).subscribe({
      next: (data) => {
        this.dependentesContent = data || [];
      },
      error: (err) => {
        console.error('❌ Erro ao carregar dependentes:', err);
        this.dependentesContent = [];
      },
    });
  }

  carregarFolhaPagamento(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.carregandoFolha = true;
    const competencia = this.form.value.competencia;
    const competenciaFormatada = this.formatarCompetenciaParaAPI(competencia);

    this.sagresService
      .buscarFolhaPagamentoContent(this.sigla, competenciaFormatada, this.empfil)
      .subscribe({
        next: (data: any) => {
          this.folhaPagamentoContent = Array.isArray(data) ? data : [];

          this.carregandoFolha = false;
        },
        error: (err) => {
          console.error('❌ Erro ao carregar folha de pagamento:', err);
          this.erroService.retornoErro('Erro ao carregar dados da folha de pagamento');
          this.folhaPagamentoContent = [];
          this.carregandoFolha = false;
        },
      });
  }

  formatarData(data: string | null): string {
    if (!data) return 'N/A';

    const d = new Date(data);
    if (isNaN(d.getTime())) return data;

    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();

    return `${dia}/${mes}/${ano}`;
  }

  private async carregarDadosServidores(competencia: string): Promise<void> {
    try {
      const dados = await this.sagresService
        .buscarServidores(this.sigla, competencia, this.empfil)
        .toPromise();

      this.servidoresContent = Array.isArray(dados?.content) ? dados.content : [];
    } catch (e) {
      console.error('Erro ao carregar servidores:', e);
      this.servidoresContent = [];
    }
  }

  temErro(campo: string): boolean {
    const control = this.form.get(campo);
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  getMensagemErro(campo: string): string {
    const control = this.form.get(campo);

    if (!control || !control.errors) return '';

    const errors = control.errors;

    if (errors['required']) return 'Campo obrigatório';
    if (errors['formatoInvalido']) return 'Formato inválido';

    return 'Campo inválido';
  }

  private obterCredencialBase64(): string {
    try {
      const utilCriptografado = localStorage.getItem('util');
      if (!utilCriptografado) return '';
      const utilDecriptado = new Crypto().decryptUsingAES256(utilCriptografado);
      const localStorageObj = JSON.parse(utilDecriptado);
      return localStorageObj?.CredencialBase64 ?? '';
    } catch {
      return '';
    }
  }

  private verificarAutenticacao(): void {
    const credencialBase64 = this.obterCredencialBase64();
    if (!credencialBase64) {
      this.router.navigate(['/login']);
      return;
    }
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
    return null;
  }

  getSigla(): string {
    return this.localStorage?.Sigla ?? '';
  }

  getEmpfil(): string {
    return String(this.localStorage?.FilialAtual ?? '');
  }

  async baixarTodosXMLs(): Promise<void> {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.baixando = true;
    this.resetarProgresso();

    const competencia = this.form.value.competencia;
    const competenciaFormatada = this.formatarCompetenciaParaAPI(competencia);

    this.progresso.total = this.xmls.length;
    this.atualizarProgresso();

    try {
      await Promise.all([
        this.carregarDadosFolhaPagamento(competenciaFormatada),
        this.carregarDadosVantagemDesconto(competenciaFormatada),
        this.carregarDadosServidores(competenciaFormatada),
        this.carregarDependentes(this.sigla, competenciaFormatada, this.empfil),
      ]);
    } catch (error) {
      console.error('❌ Erro ao carregar dados auxiliares:', error);
    }

    for (const xml of this.xmls) {
      try {
        await this.baixarXML(xml, competenciaFormatada);
      } catch (error) {
        console.error(`❌ Erro inesperado no processo de ${xml.nome}:`, error);

        xml.status = 'erro';
        this.progresso.concluidos++;
        this.atualizarProgresso();
      }
    }

    if (this.progresso.concluidos < this.progresso.total) {
      this.progresso.concluidos = this.progresso.total;
      this.atualizarProgresso();
    }

    this.baixando = false;
  }

  private async carregarDadosFolhaPagamento(competencia: string): Promise<void> {
    try {
      const dados = await this.sagresService
        .buscarFolhaPagamento(this.sigla, competencia, this.empfil)
        .toPromise();

      this.folhaPagamentoContent = Array.isArray(dados) ? dados : [];
    } catch (error) {
      console.error('❌ Erro ao carregar folha:', error);
      this.folhaPagamentoContent = [];
    }
  }

  private async carregarDadosVantagemDesconto(competencia: string): Promise<void> {
    try {
      const dados = await this.sagresService
        .buscarVantagemDesconto(this.sigla, competencia, this.empfil)
        .toPromise();

      this.vantagemDescontoContent = Array.isArray(dados?.content) ? dados.content : [];
      this.vantagemDescontoTotais = dados?.totais ?? {};
    } catch (error) {
      console.error('❌ Erro ao carregar vantagem-desconto:', error);
      this.vantagemDescontoContent = [];
      this.vantagemDescontoTotais = {};
    }
  }

  formatarCPF(cpf: string): string {
    if (!cpf) return 'N/A';

    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11) return cpf;

    return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  }

  validaCompetencia(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return { required: true };
    }

    const numeros = value.replace(/\D/g, '');
    if (numeros.length !== 6) {
      return { formatoInvalido: true };
    }

    return null;
  }

  private formatarCompetenciaParaAPI(competencia: string): string {
    if (!competencia) return '';

    const numeros = competencia.replace(/\D/g, '');

    if (numeros.length !== 6) {
      return numeros;
    }

    return numeros;
  }

  private async baixarXML(xml: XmlArquivo, competencia: string): Promise<void> {
    xml.status = 'baixando';
    xml.erro = undefined;

    try {
      const response = await this.sagresService
        .baixarXml(xml.endpoint, this.sigla, competencia, this.empfil)
        .toPromise();

      if (!response) {
        throw new Error('Resposta vazia da API');
      }

      let parsed: any = null;

      if (typeof response === 'string') {
        try {
          parsed = JSON.parse(response);
        } catch {
          parsed = null;
        }
      }

      if (parsed?.msg && parsed.msg !== 'Obtenção realizada com sucesso!') {
        throw { apiError: parsed.msg };
      }

      const base64 =
        parsed?.result?.file ||
        parsed?.file ||
        parsed?.Base64 ||
        (typeof response === 'string' ? response : null);

      if (!base64) {
        throw { apiError: 'A API não retornou dados de arquivo.' };
      }

      xml.base64 = base64;
      xml.status = 'concluido';
      xml.regs = this.contarRegistrosXML(base64);

      if (xml.endpoint === 'folha-pagamento' && this.folhaPagamentoContent.length === 0) {
        this.processarFolhaPagamentoContent(base64);
      }
    } catch (error: any) {
      xml.status = 'erro';
      xml.regs = 0;

      let mensagemErro = 'Erro desconhecido';

      let realError = error;
      if (typeof error === 'function') {
        try {
          realError = error();
        } catch (e) {}
      }

      if (realError?.error) {
        if (typeof realError.error === 'string') {
          try {
            const parsedError = JSON.parse(realError.error);
            if (parsedError?.msg) {
              mensagemErro = parsedError.msg;
            } else {
              mensagemErro = realError.error;
            }
          } catch {
            mensagemErro = realError.error;
          }
        } else if (realError.error?.msg) {
          mensagemErro = realError.error.msg;
        }
      } else if (realError?.status) {
        mensagemErro = `Erro HTTP ${realError.status}: ${
          realError.statusText || 'Method Not Allowed'
        }`;
      } else if (realError?.message) {
        mensagemErro = realError.message;
      }

      xml.erro = mensagemErro;
      this.xmls = [...this.xmls];
    }

    this.progresso.concluidos++;
    this.atualizarProgresso();
  }

  private processarFolhaPagamentoContent(base64: string): void {
    try {
      const xmlString = atob(base64);

      const contentMatch = xmlString.match(/<content>\[.*?\]<\/content>/);
      if (contentMatch) {
        const contentJson = contentMatch[0].replace(/<content>|<\/content>/g, '');
        this.folhaPagamentoContent = JSON.parse(contentJson);
      }
    } catch (error) {
      console.error('❌ Erro ao processar content da folha de pagamento:', error);
    }
  }

  private contarRegistrosXML(base64: string): number {
    try {
      const xmlString = atob(base64);

      const itemCount = (xmlString.match(/<Item/g) || []).length;

      if (itemCount === 0) {
        const mainTags = xmlString.match(/<[A-Z][A-Za-z]*>/g) || [];
        return Math.max(0, mainTags.length - 1);
      }

      return itemCount;
    } catch (error) {
      console.error('❌ Erro ao contar registros XML:', error);
      return 0;
    }
  }

  async gerarZip(): Promise<void> {
    const arquivosComSucesso = this.xmls.filter((xml) => xml.status === 'concluido' && xml.base64);

    if (arquivosComSucesso.length === 0) {
      this.erroService.retornoErro('Nenhum arquivo foi baixado com sucesso para gerar o ZIP');
      return;
    }

    this.gerandoZip = true;

    try {
      const zip = new JSZip();
      const competencia = this.form.value.competencia;

      arquivosComSucesso.forEach((xml) => {
        if (xml.base64) {
          const conteudo = this.base64ToUint8Array(xml.base64);
          zip.file(xml.nome, conteudo);
        }
      });

      const content = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: { level: 6 },
      });

      const nomeZip = this.formatarNomeZip(competencia);
      saveAs(content, nomeZip);
    } catch (error) {
      console.error('❌ Erro ao gerar ZIP:', error);
      this.erroService.retornoErro('Erro ao gerar arquivo ZIP');
    }

    this.gerandoZip = false;
  }

  private formatarNomeZip(competencia: string): string {
    const numeros = competencia.replace(/\D/g, '');

    if (numeros.length !== 6) {
      return `999033${this.sigla}_${competencia.replace('/', '_')}.zip`;
    }

    const ano = numeros.substring(0, 4);
    const mes = numeros.substring(4, 6);

    const nomeZip = `999033${mes}${ano}PE0001.zip`;

    return nomeZip;
  }

  private resetarProgresso(): void {
    this.xmls.forEach((xml) => {
      xml.status = 'pendente';
      xml.base64 = null;
    });

    this.progresso = {
      total: this.xmls.length,
      concluidos: 0,
      percentual: 0,
    };
  }

  private atualizarProgresso(): void {
    this.progresso.percentual = Math.round(
      (this.progresso.concluidos / this.progresso.total) * 100
    );
  }

  get todosBaixados(): boolean {
    const todosProcessados = this.xmls.every(
      (xml) => xml.status === 'concluido' || xml.status === 'erro'
    );

    const peloMenosUmSucesso = this.xmls.some((xml) => xml.status === 'concluido' && xml.base64);

    return todosProcessados && peloMenosUmSucesso;
  }

  get podeGerarZip(): boolean {
    return this.xmls.some((xml) => xml.status === 'concluido' && xml.base64);
  }

  get statusGeral(): string {
    const concluidos = this.xmls.filter((x) => x.status === 'concluido').length;
    const comErro = this.xmls.filter((x) => x.status === 'erro').length;
    const pendentes = this.xmls.filter(
      (x) => x.status === 'pendente' || x.status === 'baixando'
    ).length;

    return `${concluidos} sucesso, ${comErro} com erro, ${pendentes} pendentes`;
  }

  getProgressBarClass(): string {
    if (this.progresso.percentual === 100) {
      return 'progress-bar bg-success';
    } else if (this.progresso.percentual > 0) {
      return 'progress-bar progress-bar-striped progress-bar-animated bg-warning';
    } else {
      return 'progress-bar bg-info';
    }
  }

  private base64ToUint8Array(base64: string): Uint8Array {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  }

  trackByNome = (_: number, item: XmlArquivo) => item.nome;
  trackByValor = (_: number, item: CompetenciaDTO) => item.VALOR;
}

export interface XmlArquivo {
  nome: string;
  endpoint: string;
  status: 'pendente' | 'baixando' | 'concluido' | 'erro';
  base64: string | null;
  regs?: number;
  erro?: string;
}

export interface CompetenciaDTO {
  VALOR: string;
  DESCRICAO: string;
}
